// 20241102: xt - NOTE this report actions are fetching/using the collection 'reporting'!!.
//  not reportsummaries which is more robust
//   the collection 'reporting' was an intial attempt that seemed to be replaced with reportsummaries in the code.
//    need to cleanup collections and their use 
//  6-25-25 new issue, it seems that a modal 'incidentResourceModal' window needs data that is from this reporting db colletion
//     xt this will need to be looked in to to decide what is the proper way to handle this for responders
//.   20250719: fix the RECIEVE report to not write directly to an immutable state.. 
/* globals fetch, localStorage */
import Globals from "../utils/globals";
import { logException } from "../utils/AppLogger";
import { getRequestOptions } from "../utils/ApiHelper"; // Removed getToken import
import { setError } from "./findError";

export const REQUEST_REPORT = "REQUEST_REPORT";
export const RECEIVE_REPORT = "RECEIVE_REPORT";
export const REQUEST_REPORT_FAILURE = "REQUEST_REPORT_FAILURE";
// export const SET_REPORT_VISIBILITY = 'SET_REPORT_VISIBILITY'

export const requestReport = (id) => {
  return {
    type: REQUEST_REPORT,
    agencyId: id,
  };
};

export const receiveReport = (json) => {
  return {
    type: RECEIVE_REPORT,
    items: json.items.map((item) => ({ ...item })),
    totalPage: json.totalPages,
    en_count: json.en_count,
    es_count: json.es_count,
    count: json.count,
    inc_types: json.inc_types,
    timezones: json.timezones,
    languages: json.languages,
    current_language: json.current_language,
    receivedAt: Date.now(),
  };
};

export const fetchReportFailure = (error) => {
  logException(error, {
    profile: localStorage.getItem("profile"),
  });

  return {
    type: REQUEST_REPORT_FAILURE,
    error,
  };
};

// export const setReportVisibility = (visibility) => {
//   return {
//     type: SET_REPORT_VISIBILITY,
//     visibility
//   }
// }

// 20241029 xt this is fetching the collection "reportings" NOT REPORTSUMMARIES!!!
export const fetchReport = (id, token, params = {}) => {
  console.log("params", params);
  return (dispatch) => {
    let res;
    let fetchUrl;
    // let params
    if (!token) {
      console.error('report.js - No token provided');
      return dispatch(
        setError(
          null,
          "Token not found",
          "No API token available. Please log in again."
        )
      );
    }

    fetchUrl = `${Globals.apiEndpoint}/dashboard/agencies/${id}/reporting`; // xt NOTE: this is fetching the 'reporting' DB.. I dont think it is the best one
    if (Object.keys(params).length) {
      fetchUrl +=
        "?" +
        Object.keys(params)
          .map((queryParam) => `${queryParam}=${params[queryParam]}`)
          .join("&");
    }

    const requestOptions = getRequestOptions(token);

    dispatch(requestReport(id));
    return fetch(fetchUrl, requestOptions)
      .then((response) => {
        res = response;
        return response.json();
      })
      .then((json) => {
        if (res.status !== 200) {
          return dispatch(setError(res.status, res.statusText, json.message));
        } else {
          // console.log('json: ',json)
          dispatch(receiveReport(json));
        }
      })
      .catch((error) => {
        dispatch(fetchReportFailure(error));
        dispatch(setError(null, "Network Error", error.message));
      });
  };
};